module.exports = __webpack_public_path__ + "static/inculcation-of-equality-ebead8f21c3f067c18654086a03a8a7c.jpg";